/**
 * This is an application specific type, we keep the same names but change the values
 */
export enum IconStatusType {
  ACTIVE = 'streaming',
  CONNECTED = 'connected',
  CONNECTING = 'connecting',
  ERROR = 'error',
  INACTIVE = 'inactive',
  OFFLINE = 'offline',
  OK = 'ok',
  PAIRING = 'pairing',
  PAUSED = 'paused',
  READY = 'listening',
  STARTING = 'starting',
  STOPPED = 'inactive',
  STOPPING = 'stopping',
  STREAMING = 'to-storage',
  TO_STORAGE = 'to-storage',
  UNASSIGNED = 'unassigned',
  UNPAIRED = 'unpaired',
  UNPAIRING = 'disconnecting',
  WARNING = 'warning',
}

export enum IconStatus {
  StatusTranscoding = 'StatusOK',
  StatusStreamWarning = 'StatusStreamWarning',
  StatusStreamFailed = 'StatusError',
  StatusStopped = 'StatusStopped',
  StatusWarning = 'StatusWarning',
}
